import { OrderVendorId, OrderVendorResponse } from '@business/entities/order';
import { Endpoint } from '../endpoint';

export function fetchVendors() {
  return Endpoint.get<OrderVendorResponse[]>(`@gc/vendors`);
}

export function fetchVendor(id: OrderVendorId) {
  return Endpoint.get<OrderVendorResponse>(`@gc/vendors/stage/${id}`);
}

export function createVendor(data: Partial<OrderVendorResponse>) {
  return Endpoint.post<OrderVendorResponse>(`@gc/vendors`, { data });
}

export function updateVendor(id: OrderVendorId, data: Partial<OrderVendorResponse>) {
  return Endpoint.patch<OrderVendorResponse>(`@gc/vendors/${id}`, { data });
}

export function deleteVendor(id: OrderVendorId) {
  return Endpoint.delete<void>(`@gc/vendors/${id}`);
}
export function sync() {
  return Endpoint.get<OrderVendorResponse[]>(`@gc/vendors/sync`);
}
